module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-1.b55f6ada.jpg";